import { atom } from 'recoil'
import { Point } from 'types/building'

type Props = {
  selectedFloor?: number
  selectedPoint?: string
  selectedImage?: number
  selectedSubImage?: number
  isSelectPoint?: boolean
  isOpenLeftMenu: boolean
  isOpenMiniMap: boolean
  selectedArea?: string
  pointDetail?: Point
  imageIsLoading?: boolean
  isClickToDirection?: boolean
  isSelectPointInLeftMenu?: boolean
  isClickToNextFloor?: boolean
  isClickViewListFile?: boolean
  isClickFromTourCarousel?: boolean
}

const currentViewerState = atom<Props>({
  key: 'currentViewer',
  default: {
    selectedFloor: undefined,
    selectedPoint: undefined,
    selectedImage: undefined,
    selectedSubImage: undefined,
    selectedArea: undefined,
    isOpenLeftMenu: true,
    isOpenMiniMap: false,
    pointDetail: undefined,
    imageIsLoading: false,
    isClickToDirection: false,
    isSelectPointInLeftMenu: false,
    isSelectPoint: false,
    isClickToNextFloor: false,
    isClickViewListFile: false,
    isClickFromTourCarousel: false
  }
})

export default currentViewerState
